import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../DataLayer/DataLayer";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  borderRadius: "10px",
  border: "none",
  boxShadow: 24,
  p: 4,
};

function isHTML(str) {
  var doc = new DOMParser().parseFromString(str, "text/html");
  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
}

const PromoIndexEdit = ({ record, handleUpdate }) => {
  const [title, setTitle] = useState(record?.title);
  const [simplifiedChineseTitle, setSimplifiedChineseTitle] = useState(
    record?.simplified_chinese_title || ""
  );
  const [traditionalChineseTitle, setTraditionalChineseTitle] = useState(
    record?.traditional_chinese_title || ""
  );
  const [simplifiedChinesedescription, setSimplifiedChinesedescription] =
    useState(record?.simplified_chinese_description || "");
  const [traditionalChinesedescription, setTraditionalChinesedescription] =
    useState(record?.traditional_chinese_description || "");
  const [bahasaTitle, setBahasaTitle] = useState(record?.bahasa_title || "");
  const [bahasaDescription, setBahasaDescription] = useState(record?.bahasa_description || "");
  const [description, setDescription] = useState(record?.description);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [, dispatch] = useDataLayerValue();

  useEffect(() => {
    if (record) {
      setTitle(record?.title);
      setDescription(record?.description);
      setSimplifiedChineseTitle(record.simplified_chinese_title);
      setTraditionalChineseTitle(record.traditional_chinese_title);
      setSimplifiedChinesedescription(record.simplified_chinese_description);
      setTraditionalChinesedescription(record.traditional_chinese_description);
      setBahasaTitle(record?.bahasa_title || "");
      setBahasaDescription(record?.bahasa_description || "");
    }
  }, [record]);
  return (
    <>
      <div className="table_action_btn" style={{ display: "flex" }}>
        <div
          className="btn"
          onClick={() => {
            handleOpen();
          }}
        >
          <i className="ri-edit-2-line" data-toggle="tooltip" title="Edit"></i>
        </div>
      </div>

      <Modal
        open={open}
        onClose={(e) => {
          handleClose();
        }}
        sx={{ border: "none" }}
      >
        <Box sx={style}>
          {isHTML() ? (
            <h4
              style={{ fontWeight: "bold" }}
              dangerouslySetInnerHTML={{ __html: "Edit Promo Index" }}
            />
          ) : (
            <h4 style={{ fontWeight: "bold" }}>Edit Promo Index</h4>
          )}
          <form className="input_form">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                <div className="fieldrow">
                  <label className="f_label">Title</label>
                  <input
                    required
                    value={title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                    }}
                    type="text"
                    className="f_input"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                <div className="fieldrow">
                  <label className="f_label">Simplified Chinese Title</label>
                  <input
                    required
                    value={simplifiedChineseTitle}
                    onChange={(e) => {
                      setSimplifiedChineseTitle(e.target.value);
                    }}
                    type="text"
                    className="f_input"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                <div className="fieldrow">
                  <label className="f_label">Traditional Chinese Title</label>
                  <input
                    required
                    value={traditionalChineseTitle}
                    onChange={(e) => {
                      setTraditionalChineseTitle(e.target.value);
                    }}
                    type="text"
                    className="f_input"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                <div className="fieldrow">
                  <label className="f_label">Bahasa Title</label>
                  <input
                    value={bahasaTitle}
                    onChange={(e) => {
                      setBahasaTitle(e.target.value);
                    }}
                    type="text"
                    className="f_input"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                <div className="fieldrow">
                  <label className="f_label">Description</label>
                  <textarea
                    required
                    className="f_input"
                    value={description}
                    onChange={(e) => {
                      setDescription(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                <div className="fieldrow">
                  <label className="f_label">
                    Simplified Chinese Description
                  </label>
                  <textarea
                    required
                    className="f_input"
                    value={simplifiedChinesedescription}
                    onChange={(e) => {
                      setSimplifiedChinesedescription(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                <div className="fieldrow">
                  <label className="f_label">
                    Traditional Chinese Description
                  </label>
                  <textarea
                    required
                    className="f_input"
                    value={traditionalChinesedescription}
                    onChange={(e) => {
                      setTraditionalChinesedescription(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                <div className="fieldrow">
                  <label className="f_label">Bahasa Description</label>
                  <textarea
                    className="f_input"
                    value={bahasaDescription}
                    onChange={(e) => {
                      setBahasaDescription(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "right",
                marginTop: "10%",
              }}
            >
              <Button
                variant="contained"
                onClick={(e) => {
                  handleClose();
                  try {
                    if (!title) {
                      throw new Error("Please provide title");
                    }
                    if (!description) {
                      throw new Error("Please provide description");
                    }

                    handleUpdate(record.promo_index, {
                      title,
                      description,
                      simplified_chinese_title: simplifiedChineseTitle,
                      traditional_chinese_title: traditionalChineseTitle,
                      simplified_chinese_description: simplifiedChinesedescription,
                      traditional_chinese_description: traditionalChinesedescription,
                      bahasa_title: bahasaTitle,
                      bahasa_description: bahasaDescription,
                    });
                  } catch (error) {
                    dispatch({
                      type: "SET_LOADING",
                      loading: false,
                    });

                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: error.message,
                    });
                  }
                }}
              >
                Save
              </Button>
            </div>
          </form>
        </Box>
      </Modal>
      {/* </form> */}
    </>
  );
};

export default PromoIndexEdit;
